var AutocompleteCollection = (function () {

    var AutocompleteModel = Backbone.Model.extend({
        idAttribute: "id",
        initialize: function () {
        }
    });

    return Backbone.Collection.extend({
        model: AutocompleteModel
    });

})();